
import Vue from 'vue';
import {
  Label,
  LabelIdentifier,
} from '@/model';
import labels from '@/store/labels';
import DataTable, { Column } from '@/components/tables/DataTable.vue';

interface LabelWithIdentifiers {
  label?: Label;
  identifier: LabelIdentifier;
}

export default Vue.extend({
  components: { DataTable },
  props: {
    value: { type: Array as () => LabelIdentifier[], required: true },
  },
  data() {
    return {
      tableHeaders: [
        { header: 'Id', value: 'label.id', type: 'string' },
        {
          header: 'Label', value: 'label.code', type: 'string',
        },
        {
          header: 'Type', value: 'label.type', type: 'string', filterable: true,
        },
        {
          header: 'Score', value: 'identifier.score', type: 'number', sort: 'desc',
        },
        {
          header: 'Term Frequency', value: 'identifier.tf', type: 'number', sort: 'desc',
        },
        {
          header: 'Frequency', value: 'identifier.freq', type: 'number', sort: 'desc',
        },
        {
          header: 'Type total', value: 'identifier.total', type: 'number', sort: 'desc',
        },
        {
          header: 'IDF', value: 'identifier.idf.idf', type: 'number', sort: 'desc',
        },
      ] as Column[],
    };
  },
  computed: {
    labelWithIdentifiers(): LabelWithIdentifiers[] {
      return this.value.map((identifier) => {
        const label = labels.getters.lookup.get(identifier.labelId);
        return {
          label,
          identifier,
        };
      });
    },
  },

});
